import { memo } from "react";
import { OUTCOMES } from "../../data/scorecard";
import TextInput from "/src/components/UI/TextField/TextInput";
import { CardTitle, Field, SelectField } from "../shared";

function CallDetailsCard({ info, onChange, suggestions }) {
    const input = (field, props = {}) => (
        <TextInput
            className="ce-w100"
            value={info[field]}
            onChange={(event) => onChange(field, event.target.value)}
            {...props}
        />
    );

    return (
        <section className="ce-card">
            <CardTitle icon="fas fa-headset" title="Call details" hint="Who, when and how the call ended" />

            <div className="ce-grid ce-grid--4">
                <Field label="Agent" required>{input("agent", { list: "ce-agents", placeholder: "Agent name" })}</Field>
                <Field label="Manager">{input("manager", { list: "ce-managers", placeholder: "Evaluating manager" })}</Field>
                <Field label="Date">{input("date", { type: "date" })}</Field>
                <Field label="Call ID / Link">{input("callId", { placeholder: "CALL-1234 or recording URL" })}</Field>

                <Field label="Team">{input("team", { list: "ce-teams", placeholder: "e.g. Inbound" })}</Field>
                <Field label="Geo">{input("geo", { list: "ce-geos", placeholder: "e.g. DK" })}</Field>
                <Field label="Call duration">{input("duration", { placeholder: "mm:ss" })}</Field>
                <Field label="Outcome" required>
                    <SelectField name="outcome" value={info.outcome} options={OUTCOMES} placeholder="Select an outcome…" onChange={(value) => onChange("outcome", value)} />
                </Field>
            </div>

            <datalist id="ce-agents">{suggestions.agents.map((value) => <option key={value} value={value} />)}</datalist>
            <datalist id="ce-managers">{suggestions.managers.map((value) => <option key={value} value={value} />)}</datalist>
            <datalist id="ce-teams">{suggestions.teams.map((value) => <option key={value} value={value} />)}</datalist>
            <datalist id="ce-geos">{suggestions.geos.map((value) => <option key={value} value={value} />)}</datalist>
        </section>
    );
}

export default memo(CallDetailsCard);
